import {Injectable} from '@angular/core';
import {LocalStorageService} from 'app/core/services/local-storage.service';
import {CookieService} from 'ngx-cookie-service';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const UTM_TTL = 30 * 24 * 3600 * 1000; // 30 Days in  milliseconds

interface UtmTags {
    utm_referrer: string;
    utm_source: string;
    utm_campaign: string;
}

@Injectable({
    providedIn: 'root',
})
export class UtmService {
    constructor(
        protected storage: LocalStorageService,
        private cookieService: CookieService
    ) {}

    getUtm(): UtmTags {
        const local = this.getUtmLocalStorage();
        return {
            utm_referrer: local.utm_referrer,
            utm_source: this.cookieService.get('utm_source') || local.utm_source,
            utm_campaign: this.cookieService.get('utm_campaign') || local.utm_campaign,
        };
    }

    setUtmLocalStorage(utm) {
        this.storage.setItem('apd_utm', JSON.stringify({value: utm, timestamp: Date.now()}));
    }

    getUtmLocalStorage(): UtmTags {
        try {
            const {value, timestamp} = this.storage.getJson('apd_utm') as {value: Record<string, string>; timestamp: number};
            if (Date.now() - timestamp > UTM_TTL) {
                console.debug('[UtmService] getUtm expire', Date.now() - timestamp > UTM_TTL);
                return this.defaultValue();
            }
            return {
                utm_referrer: value.utm_referrer ? String(value.utm_referrer) : '',
                utm_source: value.utm_source ? String(value.utm_source) : '',
                utm_campaign: value.utm_campaign ? String(value.utm_campaign) : '',
            };
        } catch (e) {
            console.debug('[UtmService] getUtm error', e);
            return this.defaultValue();
        }
    }

    defaultValue(): UtmTags {
        return {
            utm_referrer: '',
            utm_source: '',
            utm_campaign: '',
        };
    }
}
